export default __webpack_public_path__ + "svg/CompaniesLogos/logo_garrigues.svg?1aef3845";